import React from 'react';
import { useTheme, useMediaQuery, Typography, Box } from '@mui/material';
import CChipFund from '../components/CChipFund';
import investmentFilterLang from '../features/fund-type/langs/investmentFilterLang';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import InvestorRoutes from '../InvestorRoutes';
import useInvestFunds from '../hooks/fund/useInvestFunds';
import IFund from '../interfaces/fund/IFund';
import { TInvestExpertiseTag } from '../types/expertise/TInvestExpertiseTag';

type VInvestFilteredFundsChipsProps = {
	expertiseTag?: TInvestExpertiseTag;
	outOf: number;
	filterFunds: IFund[];
};

const VInvestFilteredFundsChips = (props: VInvestFilteredFundsChipsProps) => {
	const { expertiseTag, outOf, filterFunds } = props;

	const { t } = useTranslation();
	const navigate = useNavigate();
	const { funds } = useInvestFunds();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<>
			{funds && filterFunds ? (
				<Box sx={{ marginBottom: '30px', marginTop: '18px' }}>
					{!isMobile ? (
						<Typography
							component="span"
							style={{
								fontFamily: 'Cambo',
								fontStyle: 'normal',
								fontWeight: 400,
								fontSize: '0.9rem',
								lineHeight: '1.5',
								color: theme.palette.mode === 'dark' ? 'white' : '',
							}}
						>
							{['venture_capital', 'private_equity'].includes(expertiseTag ?? '')
								? t(investmentFilterLang.view_details.tag)
								: t(investmentFilterLang.x_funds_filtered.tag, {
										outOf: outOf,
										count: filterFunds.length,
								  })}
						</Typography>
					) : (
						''
					)}{' '}
					{!isMobile ? (
						<>
							{filterFunds.map((resultFund: IFund, index: number) => {
								const fund = funds.find((x) => x.id === resultFund.id);
								if (fund && typeof fund !== 'undefined') {
									return (
										<CChipFund
											key={index}
											onClick={() =>
												navigate(
													HAppRoutes.getPath(InvestorRoutes.fund.tag, {
														investExpertiseTag: fund.typeTag ?? undefined,
														id: fund.id.toString(),
													}),
												)
											}
											disabled={fund.isRealized ?? undefined}
											label={fund.name}
										/>
									);
								}
							})}
						</>
					) : (
						<Box
							style={{
								height: '48px',
								overflowX: 'auto',
								display: 'flex',
								flexDirection: 'row',
							}}
						>
							{filterFunds.map((resultFund: IFund, index: number) => {
								const fund = funds.find((x) => x.id === resultFund.id);
								return (
									<CChipFund
										key={index}
										onClick={() =>
											navigate(
												HAppRoutes.getPath(InvestorRoutes.fund.tag, {
													investExpertiseTag: fund?.typeTag ?? undefined,
													id: fund?.id.toString(),
												}),
											)
										}
										label={fund?.name}
									/>
								);
							})}
						</Box>
					)}
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default VInvestFilteredFundsChips;
